module.exports = __webpack_public_path__ + "static/img/1-_03.97816ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/1-_03.png
// module id = ulHv
// module chunks = 0